import * as React from "react";
const SvgFiRrForwardFast = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 1a1 1 0 0 0-1 1v6.591l-6.184-4.848a3.76 3.76 0 0 0-3.95-.325 3.72 3.72 0 0 0-2.073 3.326L6.022 3.743a3.71 3.71 0 0 0-3.949-.325A3.72 3.72 0 0 0 0 6.793v10.421c0 1.455.775 2.717 2.073 3.375 1.278.649 2.79.525 3.98-.348l3.74-2.983a3.72 3.72 0 0 0 2.072 3.331 3.8 3.8 0 0 0 1.712.411c.806 0 1.58-.254 2.263-.755L22 15.407V22a1 1 0 1 0 2 0V2a1 1 0 0 0-1-1m-1.755 12.458-6.613 5.194a1.79 1.79 0 0 1-1.861.153 1.73 1.73 0 0 1-.978-1.593l-.002-2.032a1 1 0 0 0-1.624-.78l-5.33 4.252a1.77 1.77 0 0 1-1.86.153 1.73 1.73 0 0 1-.978-1.592V6.793c0-.696.356-1.276.979-1.592.619-.315 1.298-.259 1.829.13l5.362 4.27a1 1 0 0 0 1.623-.782V6.794c0-.696.356-1.276.978-1.592a1.76 1.76 0 0 1 1.835.135l6.664 5.225a1.785 1.785 0 0 1-.026 2.897z"
    />
  </svg>
);
export default SvgFiRrForwardFast;
